module.exports = __webpack_public_path__ + "media/sfx_enter_2.4ec95b6b.mp3";